import { Icon } from '@components/primitives/Icon'
import { Text } from '@components/primitives/Text'
import type { IconDefinition } from '@fortawesome/fontawesome-common-types'
import { faXmark } from '@fortawesome/pro-regular-svg-icons/faXmark'
import { trackEvent } from '@lib/tracking'
import { TrackingEvents } from '@lib/tracking/TrackingEvents'
import { TrackingSources } from '@lib/tracking/TrackingSources'

export function SelectedItems({
  icon,
  onChange,
  title,
  trackingType,
  value,
  valueDisplayCallback = (s) => s,
}: {
  icon: IconDefinition
  onChange?: (newValue: string[]) => void
  title: string
  trackingType: string
  value?: string[]
  valueDisplayCallback?: (s: string) => string
}) {
  const currentValue = value ?? []

  const handleRemoveItem = (item: string) => () => {
    const newValue = currentValue.filter((i) => i !== item)

    if (onChange) {
      onChange(newValue)
    }
    trackEvent(TrackingEvents.TRIAL_APPLICATION_SEARCH_ITEM_REMOVED, {
      source: TrackingSources.APPLY_FLOW_V2,
      type: trackingType,
      val: item,
    })
  }

  if (
    currentValue.length < 1 ||
    currentValue.every((v) => v.trim().length < 1)
  ) {
    return null
  }

  return (
    <div className='relative mt-2 flex flex-col gap-2 rounded-md'>
      <Text
        className='text-neutral900'
        element='p'
        styleName='p-small'
        value={title}
      />

      <div className='relative flex flex-wrap gap-2'>
        {currentValue.map((item) => (
          <div
            className='relative flex min-h-10 min-w-20 items-center justify-center rounded-full border-2 border-success400 bg-success50 text-center'
            key={item}
          >
            <Text
              className='flex items-center justify-center gap-2 px-6 text-success700'
              element='p'
              styleName='p-tiny'
            >
              <Icon className={'text-success700'} icon={icon} />
              {valueDisplayCallback(item)}
              <Icon
                className={'hover:cursor-pointer'}
                icon={faXmark}
                onClick={handleRemoveItem(item)}
              />
            </Text>
          </div>
        ))}
      </div>
    </div>
  )
}
